import TablaCronograma from './TablaCronograma/TablaCronograma';
import { PuestosTable } from '../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestosTable';
import { useConcurso } from '../../../../providers/ConcursoProvider';
import { GenerarAprobacion } from './GenerarAprobacion/GenerarAprobacion';
import { VerActaEvolucionar } from './VerActaEvolucionar';
import { Container } from 'react-bootstrap';
import { RequisitosGeneral } from './RequisitosGeneral';

const PrimerActa = () => {
  const concurso = useConcurso();
  const { idLlamadoConcurso } = concurso;

  return (
    <Container>
      <TablaCronograma />
      <PuestosTable idLlamadoConcurso={idLlamadoConcurso} withBases withGrilla withActions />
      <RequisitosGeneral />
      <GenerarAprobacion />
      <VerActaEvolucionar />
    </Container>
  );
};

export default PrimerActa;
